import type { CancelTokenSource } from 'axios'

import { deviceVisibilityFromApi } from '@/api/adapters/deviceAccessAdapter'
import { geolocationsApiToModel } from '@/api/adapters/geolocationsAdapter'
import { getAllLeaflets } from '@/api/leaflets'
import extractData from '@/utils/extractData'

export async function fetchLeafletsXmlOrdering(cancelToken: CancelTokenSource) {
  const result = await getAllLeaflets({ predefinedFilter: 'LEAFLET_XML_ORDERING' }, cancelToken)
  const extractedData = extractData(result)
  return extractedData.map(leafletXml => {
    return geolocationsApiToModel(deviceVisibilityFromApi(leafletXml), { includeAvailabilityType: true })
  })
}
